import { useState } from 'react';
import { useGoalsQuery } from '../api/useGoalsQuery';
import { isOptedIn } from '../../../CommonUtils/isOptedIn';

interface Params {
  clientId: string;
  isWorkflow: boolean;
}

export const useWorkflowError = ({ clientId, isWorkflow }: Params) => {
  const { data } = useGoalsQuery({ clientId });
  const [error, setError] = useState<string | null>(null);

  const onValidate = () => {
    if (!data || !isWorkflow || !isOptedIn('WorkflowInputValidation')) {
      return null;
    }

    const err = !data.goals.some(({ isSelected }) => isSelected)
      ? 'Please select at least one goal.'
      : null;

    setError(err);

    return err;
  };

  const reset = () => {
    setError(null);
  };

  return { error, onValidate, reset };
};
